import { render, staticRenderFns } from "./TagsDragInDrop.vue?vue&type=template&id=86c9efd6"
import script from "./TagsDragInDrop.vue?vue&type=script&lang=js"
export * from "./TagsDragInDrop.vue?vue&type=script&lang=js"
import style0 from "./TagsDragInDrop.vue?vue&type=style&index=0&id=86c9efd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports